<div class="modal-header bg bg-info">
  <h5 class="modal-title white">{{ title }}</h5>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-md-12 text-center">
      <h4 class="">{{ message }}</h4>
    </div>
  </div>
</div>
<div class="modal-footer d-flex justify-content-center">
  <button type="button" class="btn btn-success round box-shadow-4 mr-2" (click)="onConfirm()">
    <i class="ft-thumbs-up"></i> Confirmo
  </button>
  <button type="button" class="btn btn-warning round box-shadow-4" (click)="onCancel()">
    <i class="ft-thumbs-down"></i> Cancelar
  </button>
</div>
